import {FormControl, TextField} from "@mui/material";
import React, {useEffect} from "react";
import style from "../../assets/css/global-fields.module.scss";

const GlobalTextAriaField = ({
  placeH, // Placeholder text (Mandatory)
  type = "text", // Default type is 'text'
  onChange, // Function to handle change event (Mandatory)
  onBlur, // Function to handle blur event (Mandatory)
  value, // Value to bind to the input (Mandatory)
  id, // id of the input (Mandatory)
  inputRef, // Optional: Reference for the input
  label, // Optional: Label for the input
  error, // Optional: Error prop to show if there's a validation error
  helperText, // Optional: Helper text to show error messages
  name, // Optional: Name for the input field (mandatory in Formik)
  fullWidth = true, // Optional: Default to full width
  row = 1,
}) => {
  // Check if error and helperText props are passed and set defaults if not
  const hasError = error !== undefined ? error : false;
  const errorText = helperText || "";

  useEffect(() => {
    const textareas = document.querySelectorAll(".MuiInputBase-inputMultiline");
    textareas.forEach((textarea) => {
      if (!textarea.hasAttribute("aria-label")) {
        textarea.setAttribute("aria-label", "Your text area label");
      }
    });
  }, []);

  return (
    <div className={style.proposalTextAriaField}>
      {/* This label is provided only to fix the ADA error, not to display it on the screen. */}
      <label
        style={{
          opacity: "0",
          position: "absolute",
          zIndex: "-99px",
          top: "0",
          left: "0",
        }}
        htmlFor={name}
      >
        Email
      </label>

      <FormControl fullWidth={fullWidth} className="globalTextArea">
        <TextField
          id={id} // Use the provided id
          // label="Multiline"
          rows={row}
          multiline
          variant="outlined"
          placeholder={placeH} // Set the placeholder dynamically
          value={value} // Controlled input value
          onChange={onChange} // onChange handler for input
          onBlur={onBlur} // onBlur handler for input
          inputRef={inputRef} // Optional ref for the input
          error={hasError} // Show error styling if true
          helperText={errorText} // Show error message below the input if any
          name={name} // Formik's name attribute (optional)
        />
      </FormControl>
    </div>
  );
};

export default GlobalTextAriaField;
